import { EXPERIMENTS, type CheckoutFormVariant } from '../../shared/utils/experiments';

export function useCheckoutFormVariant() {
  const { getVariation } = useGrowthBook();
  const appConfig = useAppConfig();
  const checkoutFormVariant = computed(() => (appConfig.checkoutFormVariant as CheckoutFormVariant | '')
    || getVariation<CheckoutFormVariant>(EXPERIMENTS.CHECKOUT_WHITENING, 'control'));
  const isCheckoutVariantA = computed(() => checkoutFormVariant.value === 'a');
  const isCheckoutVariantB = computed(() => checkoutFormVariant.value === 'b');
  const isCheckoutVariantC = computed(() => checkoutFormVariant.value === 'c');
  const isCheckoutVariantD = computed(() => checkoutFormVariant.value === 'd');
  const isCheckoutVariantE = computed(() => checkoutFormVariant.value === 'e');

  return {
    checkoutFormVariant,
    isCheckoutVariantA,
    isCheckoutVariantB,
    isCheckoutVariantC,
    isCheckoutVariantD,
    isCheckoutVariantE,
  };
}
